import { Descriptions, DescriptionsProps, Typography, theme } from 'antd';
import { FC, ReactNode, memo } from 'react';

interface Props extends Omit<DescriptionsProps, 'children' | 'items' | 'layout'> {
  items: [[string, ReactNode], ...([string, ReactNode] | null)[]];
  layout?: DescriptionsProps['layout'];
  titleSize?: 'small' | 'default';
}

export const DescriptionBlock: FC<Props> = memo(({ items, title, titleSize = 'default', layout = 'vertical', ...otherProps }) => {
  const { token } = theme.useToken();

  return (
    <Descriptions
      { ...otherProps }
      layout={ layout }
      title={
        title
          ? (titleSize === 'small'
            ? <Typography.Text style={{ fontSize: 12, color: token.colorTextHeading, }}>{ title }</Typography.Text>
            : <Typography.Title level={ 5 } style={{ marginBottom: 0 }}>{ title }</Typography.Title>
          )
          : undefined
      }
    >
      { items.map(
        (item, i) =>
          item && (
            <Descriptions.Item key={ i } label={ item[0] } labelStyle={{ color: token.colorTextDescription, fontSize: 12 }}>
              { item[1] }
            </Descriptions.Item>
          )
      ) }
    </Descriptions>
  );
});
